import React, { useState, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import styled from "styled-components";
import brand from "../../assets/images/logos/logo2.png";
import google from "../../assets/google.png";
import { auth, db } from "../../firebase";
import firebase from "../../firebase";
import { userContext } from "../../App";
import '../../signin.css';
// import icon from '../../assets/info2.png';
import NotverifiedModal from "./NotverifiedModal";
import ForgotPasswordModal from "./ForgotPasswordModal";
// import Navbar from "../layouts/Navbar";

const SignIn = (props) => {
  window.scrollTo(0, 0);
  const { state, dispatch } = useContext(userContext);
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showError, setshowError] = useState('');
  const [requiredError, setrequiredError] = useState('');
  const [open, setopen] = useState(false);
  const [forgotpassword, setforgotpassword] = useState(false);

  const onSigninClick = () => {
    if (email === '' || password === '') {
      setrequiredError('*Required');
      setshowError('');
    }
    else {
      setrequiredError('');
    }
  }

  const handleGoogleAuthentication = async () => {
    var provider = new firebase.auth.GoogleAuthProvider();
    try {
      const data = await auth.signInWithPopup(provider);
      let exist = false;
      await db.collection('users').get().then(
        snapshot => snapshot.docs.map(
          doc => {
            if (doc.data().email === auth.currentUser.email) {
              exist = true;
            }
          }
        )
      )
      if (!exist) {
        db.collection("users").doc(auth.currentUser.uid).set({
          email: auth.currentUser.email,
          name: auth.currentUser.displayName,
          follower: [],
          follower_Count: 0,
          saved: [],
          profilePic: "",
          description: "No Description to show",
          noti: true,
        });
      }
      const res = db.collection('users').doc(auth.currentUser.uid);
      const follower = (await res.get()).data().follower;
      const follower_Count = (await res.get()).data().follower_Count;
      const saved = (await res.get()).data().saved;
      const noti = (await res.get()).data().noti;
      const userData = {
        uid: auth.currentUser.uid,
        email: auth.currentUser.email,
        name: auth.currentUser.displayName,
        follower: follower,
        follower_Count: follower_Count,
        saved: saved,
        noti: noti,
      };
      localStorage.setItem("user", JSON.stringify(userData));
      localStorage.setItem('allowed', '1');
      dispatch({ type: "USER_SIGNIN", payload: userData });
      console.log(data);
      history.push("/home"); //Redirect to home after signed in sucessfully
    } catch (err) {
      console.log(err);
    }
  };

  //Network request for signIn user
  const handleLoggedInCredentials = async (e) => {
    e.preventDefault();
    try {
      setshowError('');
      const signIn = await auth.signInWithEmailAndPassword(
        email.trim(),
        password
      );
      if (auth.currentUser.emailVerified) {
        const res = db.collection('users').doc(auth.currentUser.uid);
        const name = (await res.get()).data().name;
        const follower = (await res.get()).data().follower;
        const follower_Count = (await res.get()).data().follower_Count;
        const saved = (await res.get()).data().saved;
        const noti = (await res.get()).data().noti;
        const userData = {
          uid: auth.currentUser.uid,
          email: auth.currentUser.email,
          name: name,
          follower: follower,
          follower_Count: follower_Count,
          saved: saved,
          noti: noti,

        };
        console.log("USER SIGN IN SUCCESSFULLY");
        localStorage.setItem("user", JSON.stringify(userData));
        localStorage.setItem('allowed', '1');
        dispatch({ type: "USER_SIGNIN", payload: userData });
        history.push("/home");
      }
      else {
        setopen(true);
      }
    } catch (err) {
      if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password') {
        setshowError('Email Address or Password Incorrect');
      }
    }
  };

  const forgotPassword = async () => {
    auth.onAuthStateChanged(async (user) => {
      auth
        .sendPasswordResetEmail(email)
        .then(function () {
          setforgotpassword(true);
          setrequiredError('');
        })
        .catch(function (error) {
          console.log(error);
          if (error.code === 'auth/invalid-email') {
            setrequiredError('*Email Required');
          }
        });
    });
  };

  const Line = ({ color }) => (
    <hr
      style={{
        color: color,
        backgroundColor: color,
        height: -1,
        width: 150,
        margin: 10,
      }}
    />
  );
  return (
    <React.Fragment>
      {/* Logo here */}
      <div className='comlogo'>
        <img src={brand} onClick={(e) => window.location.href = '/'} />
      </div>

      {/* Main Content */}
      <div className='content'>
        {open ? <NotverifiedModal open={true} setOpen={setopen} /> : null}
        {forgotpassword ? <ForgotPasswordModal open={true} setforgotpassword={setforgotpassword} /> : null}
        {requiredError !== '' ? requiredError === '*Email Required' ? <p className='requiredError'>{requiredError}</p> : <p className='requiredError'>{requiredError}</p> : null}
        {!requiredError ? <p className='error'>{showError}</p> : null}
        <div>
          <form onSubmit={(e) => handleLoggedInCredentials(e)}>
            <div>

              <h2 className='heading'>Sign In</h2>

              <div style={{ 'margin-bottom': '-10px' }}>
                <label style={{ cursor: 'default' }}>Email Address <span>*</span></label>
              </div>

              <input className='input' aria-label="email" aria-required="true" autocapitalize="off" autocorrect="off" maxlength="75" name="email" type="email" onChange={(e) => setEmail(e.target.value)} />

              <div style={{ 'margin-bottom': '-10px' }}>
                <label style={{ cursor: 'default' }}>Password <span>*</span></label>
              </div>

              <input className='input' aria-label="Password" aria-required="true" autocapitalize="off" autocorrect="off" name="password" type="password" onChange={(e) => setPassword(e.target.value)} />

            </div>
            <div>
              <button className='signin-button' onClick={onSigninClick}>SIGN IN</button>
            </div>
            <button className='google-button' onClick={handleGoogleAuthentication}>
              <span>
                <img src={google} />
              </span>
              <span
                className='continue'
                style={{
                  fontFamily: "Rubik",
                }}
              >
                Continue With Google
              </span>
            </button>
            <p style={{ cursor: 'default' }}><span className='forgotpassword' onClick={forgotPassword}>Forgot password ?</span></p>

            <div className='or'>
              <hr className='hr-left' />
              <div className='or-text' style={{ fontFamily: "Rubik" }}>OR</div>
              <hr className='hr-left' />
            </div>

            <Link to="signup">
              {" "}
              <button className='create-account-button'>CREATE ACCOUNT</button>
            </Link>
          </form>
        </div>


      </div>

    </React.Fragment>
  );
};

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const GoogleButton = styled.button`
  display: flex;
  flex-direction: row;
  /* justify-content:space-around; */
  align-items: center;
  border-radius: 31.55px;
  text-align: center;
  background: #3e6ae1;
  font-size: 17px;
  font-weight: 500;
  color: white;
  border: none;
  width: 400px;
  height: 48px;
  /* padding-bottom:px; */
  margin-top: -1.5vh;
  cursor: pointer;
`;
const ForgotBlock = styled(Content)`
  flex-direction: row;
  margin-top: 2vh;
`;

const Space = styled(ForgotBlock)`
  position: relative;
  top: 4.56vh;
  margin-bottom: 3vh;
  margin-top: -10vh
`;

const Para = styled.p`
  font-size: 17px;
  font-family: Rubik;
  font-weight: 600;
  color: #595555;
  margin-left: 20px;
  padding-bottom: 1vh;
`;
const ParaA = styled(Para)`
  font-weight: 500;
  cursor: pointer;
  padding-left: 15vw;
  padding-top: 2.3vh;
  color: black;
  font-size: 15px;
  margin-top:20px;
  @media (min-width: 1440px){
    padding-top: 1.5vh;
  }
`;

const Logo = styled.img.attrs({
  src: brand,
})`
  height:60%;
  width:100%;
  padding: 0vh 0vw 0vh 1.91vw;
`;

const Google = styled.img.attrs({
  src: google,
})`
  height: 6.2vh;
  width: 3.1vw;
  position: relative;
  margin-left: 0.1vw;
  /* padding:30px 0px 30px 20px; */
`;
const Heading = styled(Para)`
  font-size: 40px;
  font-weight: 600;
  font-family: Rubik;
  position: relative;
  color: black;
  right: 115px;
  margin-bottom: 4.5vh;
  margin-left: -1vw;
`;

const Input = styled.input.attrs((props) => ({
}))`
  background-color: #d6d3d3;
  width: 24.9vw;
  border: none;
  border-radius: 31.55px;
  padding: 2.28vh 1.1vw;
  margin: 0.76vh 0vw;
  margin-bottom: 3vh;
  outline: none;
`;
const Button = styled.button`
  border-radius: 31.55px;
  background: #3e6ae1;
  font-family: Rubik;
  font-size: 17px;
  font-weight: 500;
  color: white;
  border: none;
  width: 26.35vw;
  height: 7vh;
  padding: 1.3vh 1.1vw;
  margin-bottom: 3vh;
  cursor: pointer;
`;
const CreateButton = styled(Button)`
  border: 4px solid black;
  width: 28.55vw;
  background: transparent;
  color: #595555;
  position: relative;
  top: 7.61vh;
`;
export {
  Content,
  Input,
  Button,
  Para,
  ParaA,
  Logo,
  GoogleButton,
  Google,
};
export default SignIn;
